<template>
  <div>
    <Loader :loading="loading" />
    <v-btn color="primary" class="mr-2" @click="getDealers(false)" text
      >Обновить</v-btn
    >
    <v-btn color="danger" class="mr-2" @click="newUser = true" text
      >Добавить</v-btn
    >
    <!-- <v-btn @click="clearRange" color="danger" class="mr-2" text>Добавить</v-btn> -->
         <div class="mt-2">
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Поиск..."
      class="sticky search"
      :loading="loadingSearch"
      single-line
      hide-details
      clearable="true"
    ></v-text-field>
    </div>
    <v-data-table :headers="headers" :items="dealersList" hide-actions>
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="subheading font-weight-light text-success text--darken-3"
          v-text="header.text"
        />
      </template>
      <template slot="items" slot-scope="{ item, index }">
        <td class="text-xs-left">{{ item.id }} <span v-if="item.ID_1C">/ {{item.ID_1C}}</span></td>
        <td class="text-xs-left min-width">
          <span v-if="item.curator.length">{{ item.curator[0].name }}</span>
          <span v-else>Не установлен</span>
        </td>
        <td class="text-xs-left min-width">
          <span v-if="item.role">{{ item.role.title }}</span>
          <span v-else>Не установлена</span>
        </td>
        <td class="text-xs-left">
          <span v-if="item.is_active" class="text-success">Активен</span>
          <span v-else class="error--text">Не активен</span>
        </td>
        <td class="text-xs-left">
          <span @click="SET_USER(item.id)" class="user-link">
            
            {{ item.first_name + " " + item.last_name }} {{ item.phone_number }}
          </span>
  
        </td>
        <td class="text-xs-left">
        
          <span
            v-if="item.distributor"
            @click="SET_USER(item.distributor.id)"
            class="user-link"
          >
            <v-icon class="mr-2">mdi-account-star</v-icon>
            {{ item.distributor.title }}
          </span>  
        </td>
        <td class="text-xs-right">{{ item.created_at | dateTime }}</td>
      </template>
    </v-data-table>
    <div class="horizontal-scroll">
      <v-pagination
        v-if="last_page > 1"
        v-model="page"
        total-visible="20"
        class="my-4"
        :length="last_page"
      ></v-pagination>
    </div>
    <Dealer />

    <v-dialog
      width="600"
      persistent
      transition="dialog-bottom-transition"
      v-model="newUser"
    >
      <v-card>
        <v-card-text>
          <div class="body-2 mb-2">Новый пользователь</div>
          <small>Регион</small>
          <multiselect
            v-model="regionSelected"
            :options="region"
            :multiple="false"
            placeholder="Выберите"
            track-by="id"
            :loading="addressLoading"
            label="title"
            @input="setRegion"
          >
            <span slot="noResult">Нет такой категории</span>
          </multiselect>
          <br />
          <small>Город/район</small>
          <multiselect
            v-model="citySelected"
            :options="city"
            :loading="addressLoading"
            :multiple="false"
            :disabled="!city.length"
            placeholder="Фильтр по городу (району)"
            track-by="id"
            label="title"
          >
            <span slot="noResult">Нет такой категории</span>
          </multiselect>

           <br />
          <small>Установить роль</small>
            <multiselect
              class="mt-3"
              v-model="roleSelected"
              :options="roles"
              :multiple="false"
              placeholder="Выберите"
              track-by="id"
              :loading="groupLoading"
              label="title"
              @input="setRole"
              @remove="removeRole"
            ></multiselect>  


          <br />
          <small>Установить связь с (парнером / дистрбьютером)</small>
          <multiselect
              v-model="mainSelected"
              tag-placeholder="Введите номер"
              selectedLabel="Применен"
              placeholder="Поиск дистрибьютоеров"
              :showLabels="false"
              label="title"
              track-by="id"
              :loading="findLoading"
              :options="distrList"
              :taggable="true"
              :multiple="false"
              @search-change="asyncFindDistributors"
          ></multiselect>

          <v-text-field
            v-model="user.mark"
            label="Название торговой точки"
            hide-details
          >
          </v-text-field>
          
          <v-text-field
            v-model="user.outlet"
            label="Адрес торговой точки / Номер магазина"
            hide-details
          >
          </v-text-field>

          <v-text-field
            v-model="user.phone_number"
            label="Введите номер телефона"
            hide-details
          >
          </v-text-field>
          <v-text-field
            v-model="user.first_name"
            label="Введите имя"
            hide-details
          >
          </v-text-field>
          <v-text-field
            v-model="user.last_name"
            label="Введите Фамилию"
            hide-details
          >
          </v-text-field>
         
          <v-text-field
            v-model="user.ID_1C"
            label="ID 1C"
            hide-details
          >
          </v-text-field>

          <v-text-field v-model="user.email" label="Введите Email" hide-details>
          </v-text-field>

          <v-text-field
            v-model="user.password"
            label="Введите пароль"
            hide-details
          >
          </v-text-field>
      
          <v-text-field
            v-model="user.password_confirmation"
            label="Повторите пароль"
            hide-details
          >
          </v-text-field>

          <br />
          <br />
        </v-card-text>
        <v-divider> </v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="success" text @click="addUser"
            >Добавить пользователя
          </v-btn>
          <v-btn color="primary" text @click="newUser = false">Отмена </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loader from "../helper/Loader";
import Search from "../helper/Search";
import { mapMutations, mapState } from "vuex";
import Dealer from "./Dealer";

export default {
  props: {
    role: {
      default: 1,
    },
    no_role: {
      default: null,
    },
  },
  data: () => ({

    roles: [
      {
        id: 1,
        title: "Продавец",
      },
      {
        id: 2,
        title: "Субдистрибьютор",
      },
      {
        id: 3,
        title: "Партнер",
      },
    ],
    roleSelected: null,
    mainSelected: null,
    distrList : [],

    region: [],
    city: [],
    regionSelected: {},
    citySelected: {},
    addressLoading: true,
    user: {
      first_name: "",
      last_name: "",
      phone_number: "",
      password: "",
      password_confirmation: "",
      email: "",
      mark: "",
      location_id: null,
      ID_1C: null,
    },
    newUser: false,
    search: "",
    page: 1,
    total: 0,
    isActiveSet: 0,
    searcher: null,
    loadingSearch: true,
    last_page: 0,
    loading: true,
    headers: [
      {
        sortable: false,
        text: "ID",
        value: "rate",
      },
      {
        sortable: false,
        text: "Куратор",
        value: "title",
      },
      {
        sortable: false,
        text: "Роль",
        value: "title",
      },
      {
        sortable: false,
        text: "Статус",
        value: "title",
      },
      {
        sortable: false,
        text: "Пользователь",
        value: "phone_number",
      },
      {
        sortable: false,
        text: "",
        value: "phone_number",
      },

      {
        sortable: false,
        text: "Дата регистрации",
        value: "count_activation",
        align: "right",
      },
    ],
    dealersList: [],
  }),
  methods: {
    ...mapMutations(["SET_USER"]),

    asyncFindDistributors(query) {
      this.findLoading = true;
      axios
        .get("admin/users/list", {
          params: {
            search: query,
          },
        })
        .then((response) => {
          this.distrList = response.data.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.findLoading = false;
          }, 400);
        });
    },

    getDealers(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/users/list", {
          params: {
            page: this.page,
            search: this.search,
            role: this.role,
            no_role: this.no_role,
          },
        })
        .then((response) => {
          this.dealersList = response.data.data;
          this.total = response.data.total;
          this.last_page = response.data.last_page;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
        });
    },

    addUser() {

      this.user['location_id'] = (this.citySelected) ? this.citySelected.id : null;
      this.user['dealer_id'] = (this.mainSelected) ? this.mainSelected.id : null;
      this.user['role_id'] = (this.roleSelected) ? this.roleSelected.id : null;
      axios
        .post("admin/users/add", this.user)
        .then((response) => {
          this.$toast.success({
            title: this.vendor_code,
            message: "Аккаунт успешно добавлен",
          });
          this.user = {
            first_name: "",
            last_name: "",
            phone_number: "",
            password: "",
            password_confirmation: "",
            email: "",
            outlet: "",
            mark: "",
            location_id: 2,
          };
          this.getDealers();
          this.newUser = false;
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getRegion() {
      axios
        .get("admin/locations/list", {
          params: {},
        })
        .then((response) => {
          this.region = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.addressLoading = false;
        });
    },
    setRegion() {
      this.addressLoading = true;
      this.city = [];
      this.citySelected = {};
      axios
        .get("admin/locations/list", {
          params: {
            region: this.regionSelected.id ? this.regionSelected.id : null,
            is_city: 1,
          },
        })
        .then((response) => {
          this.city = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.addressLoading = false;
        });
    },
  },
  watch: {
    search() {
      this.page = 1;

      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getDealers(true);
      }, 1000);
    },
    page() {
      setTimeout(() => {
        this.getDealers();
      }, 300);
    },
    role(val) {
      setTimeout(() => {
        this.page = 1;
        this.getDealers();
      }, 300);
    },
  },

  computed: {
    ...mapState(["badge"]),
  },
  components: { Dealer, Search, Loader },
  mounted() {
    this.getRegion();
    this.getDealers();
  },
};
</script>

<style>
.v-text-field__slot {
  border-bottom: 1px solid #ebebeb;
}
</style>
